import clsx from 'clsx'
import React, { forwardRef } from 'react'

export const Checkbox = forwardRef(function Checkbox({ className, ...props }, ref) {
  return (
    <input
      ref={ref}
      type="checkbox"
      {...props}
      className={clsx(
        'h-4 w-4 rounded border-zinc-300 text-zinc-900 shadow-sm focus:ring-2 focus:ring-blue-500/30 focus:ring-offset-0',
        className
      )}
    />
  )
})
